export enum CmsPageEnvironmentEnum {
  DEV = 1,
  QA = 2,
  STAGING = 3,
  PROD = 4,
}
